import { useQuery } from '@tanstack/react-query';
import getBreak from 'Api/monitoring/getBreak';
import getBreakResponse from './model/response/getBreakResponse';
import { isEmpty } from 'lodash';

const useGetBreak = (monitoringStatus) => {
  const presenceId = monitoringStatus?.presence?.id;

  return useQuery({
    queryKey: ['break'],
    queryFn: async () => {
      const response = await getBreak(presenceId);

      const result = getBreakResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: !isEmpty(presenceId),
  });
};

export default useGetBreak;
